import { render, staticRenderFns } from "./donut_component.vue?vue&type=template&id=34a14871"
import script from "./donut_component.vue?vue&type=script&lang=js"
export * from "./donut_component.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports